import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import anime from 'animejs/lib/anime.es.js';
import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';

@Component({
  selector: 'app-empty-state-card',
  standalone: true,
  imports: [CommonModule, SvgLoaderComponent],
  templateUrl: './empty-state-card.component.html',
  styleUrl: './empty-state-card.component.scss'
})
export class EmptyStateCardComponent {
  @Input() messageText: string = 'No Data to Display';
  @Input() affirmText: string = null;
  @Output() affirmedAction: EventEmitter<any> = new EventEmitter<any>();
  @Input() mb: string = '0px';
  @Input() mt: string = '0px';

  constructor() { }

  private dotsAnimeTimeline: any;
  private checkSvgInterval: any;

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.checkForSvg();
  }

  checkForSvg() {
    this.checkSvgInterval = setInterval(() => {
      const svgElement = document.querySelector('.animation svg');
      if (svgElement) {
        this.animateSvg();
        clearInterval(this.checkSvgInterval);
      }
    }, 250);
  }

  animateSvg() {
    setTimeout(() => {
      this.dotsAnimeTimeline = this.createAnimeTimeline({ loop: true });
      this.animateEmptyStateDots(this.dotsAnimeTimeline);
    }, 50);
  }

  ngOnDestroy() {
    this.dotsAnimeTimeline = null;
    if (this.checkSvgInterval) {
      clearInterval(this.checkSvgInterval);
    }
  }

  onClickAffirm() {
    this.affirmedAction.emit();
  }

  createAnimeTimeline(options) {
    return anime.timeline({
      autoplay: true,
      loop: options?.loop || false,
    });
  };

  animateEmptyStateDots(timeline) {
    setTimeout(() => {
      timeline
        .add({
          targets: '.dot',
          opacity: [0, 1, 1, 0],
          translateY: [0, -5, 0],
          translateX: () => anime.random(-4, 6.75),
          duration: 2400,
          easing: 'easeInOutSine',
          delay: anime.stagger(anime.random(80, 150)),
        })
    }, 150);
  };
}
